module.exports = __webpack_require__.p + "ac27c3d31751ee5f560ad45c4f29ab28.jpg";